/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const providerService = {
  getList: (params: any) => request.get('/dc/provider', { params }),
  createProvider: (data: any) => request.post('/dc/provider', data),
  getProviderSettlementById: (id: string, params: any) =>
    request.get(`/dc/settlement/${id}`, { params }),
  getListCheck: (params: any) => request.get('/dc/provider/check', { params }),

  createProviderSettlement: (data: any) =>
    request.post('/dc/provider/settlement', data),
  getProviderListExcel: (params: any) =>
    request.get('/report/dc/provider/excel', { params })
};

export default providerService;
